import { ChevronDown } from "lucide-react";
import Reveal from "./Reveal";

/**
 * Accordéon de questions fréquentes en <details> natif : le contenu reste
 * présent dans le DOM même replié, donc lisible par tous les robots.
 */
export default function FaqAccordion({ items, prefix = "faq-item" }) {
    return (
        <div className="space-y-3">
            {items.map(([q, a], i) => (
                <Reveal key={q} delay={Math.min(i * 0.05, 0.25)}>
                    <details className="faq-item card p-0" data-testid={`${prefix}-${i + 1}`}>
                        <summary
                            className="flex cursor-pointer items-center justify-between gap-4 px-6 py-5"
                            data-testid={`${prefix}-${i + 1}-trigger`}
                        >
                            <h3 className="text-base font-bold text-ink md:text-lg">{q}</h3>
                            <ChevronDown
                                size={18}
                                aria-hidden="true"
                                className="faq-chevron shrink-0 text-terrat"
                            />
                        </summary>
                        <p className="px-6 pb-6 text-ink2" data-testid={`${prefix}-${i + 1}-answer`}>
                            {a}
                        </p>
                    </details>
                </Reveal>
            ))}
        </div>
    );
}
